<div class="page">
    <div class="page__content">
        <h1 class="header">{{'step_data.title' | translate}}</h1>
        <p>{{'step_data.text' | translate}}</p>
        <form class="form" [formGroup]="dataForm">
            <custom-form-field
                    type="text"
                    [label]="'step_data.field_name' | translate"
                    controlName="name"
                    [formGroup]="dataForm">
            </custom-form-field>

            <custom-form-field
                    type="text"
                    [label]="'step_data.field_surname' | translate"
                    controlName="surname"
                    [formGroup]="dataForm"
            >
            </custom-form-field>

            <custom-form-field
                    *ngIf="isClient"
                    type="text"
                    [label]="'step_data.field_nif' | translate"
                    controlName="nif"
                    [formGroup]="dataForm"
            >
            </custom-form-field>

        </form>
    </div>

    <div class="page__footer">
        <button
                customButton
                customOnboardingNext
                [disabled]="dataForm.invalid"
                expand="full"
                size="large"
        >
            {{'step_data.button_next' | translate}}
        </button>
    </div>
</div>
